/** 查询厂牌的key */
export const fetchNewCarBrandsApi = Symbol('@API/fetchNewCarBrandsApi')
/** 查询车款的key */
export const fetchNewCarKindsApi = Symbol('@API/fetchNewCarKindsApi')
/** 查询车型的key */
export const fetchNewCarModelsApi = Symbol('@API/fetchNewCarModelsApi')
/** 查询跑马灯的key */
export const fetchRaceApi  = Symbol('@API/fetchRaceApi')
/** 菜單篩選條件 */
export const fetachMenuFilterApi = Symbol('@API/fetachMenuFilterApi')
/** 菜单列表 */
export const fetchMenuApi = Symbol('@API/fetchMenuApi')
/** 菜单详情 */
export const fetchMenuDetailApi = Symbol('@API/fetchMenuDetailApi')
/** 地區數據key */
export const fetchRegionsApi = Symbol('@API/fetchRegionsApi')
/** 是否登錄key */
export const fetchIsLoginApi = Symbol('@API/fetchIsLoginApi')
/** 获取评论列表key */
export const fetchCommentListApi = Symbol('@API/fetchCommentListApi')